module.exports = __webpack_public_path__ + "img/Trooperz_Items_PNG.83b6fa46.png";